import React, { Component, Fragment } from 'react';

import './App.css';
import ComponentsList from './ComponentsList';

class App extends Component {
  render() {
    return (
      <Fragment>
        <main className="main-container">
          <div className="title-holder">
            <h1 className="header">React Epic Spinners</h1>
            <h5 className="sub-header">
              React Implementation of &nbsp;
              <a
                className="link"
                href="http://epic-spinners.epicmax.co/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Epic Spinners
              </a>
            </h5>

            <div className="get-started">
              <div className="get-started__docs">
                <h4>Get started</h4>
                <a
                  className="docs"
                  href="https://github.com/bondz/react-epic-spinners"
                >
                  Docs
                </a>
              </div>
              <code className="get-started-code">
                <p>npm install react-epic-spinners</p>
                <p>yarn add react-epic-spinners</p>
              </code>
            </div>
          </div>

          <ComponentsList />
        </main>
        <footer>
          <h4>
            By &nbsp;
            <a className="link" href="https://github.com/bondz">
              @bondz
            </a>
          </h4>
          <p>
            This project is an implementation of the &nbsp;
            <a
              className="link"
              href="https://github.com/epicmaxco/epic-spinners"
              target="_blank"
              rel="noopener noreferrer"
            >
              Epic Spinners
            </a>
            &nbsp; project created by &nbsp;
            <a
              className="link"
              href="https://github.com/epicmaxco"
              target="_blank"
              rel="noopener noreferrer"
            >
              EpicMax
            </a>
          </p>
        </footer>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js